import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import BoardTrend from 'components/molecules/Board/BoardTrend';
import {
	actionCreators,
	getAnamnesisTimestamp,
	getCurrentWeight,
	getDesiredWeight,
	getHealthGoal,
	getInitialWeightLost,
	getRangeDifference,
	getWeightLost,
	getWeightReduceGoal,
} from 'store/dashboard';
import { actionCreators as viewAC } from 'store/view';
import { SCROLL_ELEMENT_ID } from 'types/ScrollElementId';

export type StateType = {
	dashboard: {
		overview?: {
			latestBadges?: any[];
			totalBadges?: number;
		};
	};
};

const mapStateToProps = (state: any) => ({
	rangeDiff: getRangeDifference(state),
	currentWeight: getCurrentWeight(state),
	desiredWeight: getDesiredWeight(state),
	weightReduceGoal: getWeightReduceGoal(state),
	healthGoal: getHealthGoal(state),
	initialWeightLost: getInitialWeightLost(state),
	anamnesisTimestamp: getAnamnesisTimestamp(state),
	weightLost: getWeightLost(state),
	badges: state.dashboard.overview ? state.dashboard.overview.latestBadges : [],
	totalBadges: state.dashboard.overview ? state.dashboard.overview.totalBadges : null,
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...actionCreators,
			doSaveScrollPosition: viewAC.doSaveScrollPosition.bind(null, SCROLL_ELEMENT_ID.DASHBOARD),
		},
		dispatch
	);
};

const connector: any = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(connector(BoardTrend));
